import React from 'react'
import { Box, Typography, Button, Paper, Zoom, Fade } from '@mui/material'
import Logo from '../../components/common/Logo'
import { useAuth } from '../../hooks'

const AdLogin: React.FC = () => {
	const { login, loading } = useAuth()

	return (
		<Box
			component="main"
			className="flex items-center justify-center min-h-screen bg-gradient-to-b from-gray-100 to-gray-300 dark:from-background-dark dark:to-gray-900"
		>
			<Zoom in timeout={800}>
				<Paper
					elevation={6}
					className="p-6 rounded-lg bg-white dark:bg-background-dark shadow-lg backdrop-blur-md max-w-sm w-full text-center relative z-10 overflow-hidden border border-gray-200"
				>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							mb: 2,
							width: '100%',
						}}
					>
						<Logo imageOnly />
					</Box>

					<h1 className="text-3xl font-bold text-gray-800 dark:text-text-main-dark">
						Aura
					</h1>
					<Typography className="text-gray-500 text-sm mt-1 mb-10">
						powered by{' '}
						<span className="text-gray-800 dark:text-text-table-dark font-bold">
							Solarion AI
						</span>
					</Typography>

					<Fade in timeout={1200}>
						<Typography
							variant="h4"
							gutterBottom
							className="text-2xl dark:text-text-table-dark font-bold mb-5"
						>
							Choose a login method
						</Typography>
					</Fade>

					<div className="flex flex-col gap-3 items-center">
						{/* TEMPORARILY DISABLED: AD auth */}
						<Button
							variant="contained"
							size="large"
							disabled={true}
							onClick={() => login('azure')}
							className="bg-[#2563EB] text-white font-bold py-2 px-4 rounded-lg w-3/4 opacity-50 cursor-not-allowed"
							title="Azure AD authentication is temporarily disabled"
						>
							Sign in with Microsoft (Azure AD)
						</Button>

						<Button
							variant="contained"
							size="large"
							disabled={loading}
							onClick={() => login('auth0')}
							className="bg-[#FF841B] text-white font-bold py-2 px-4 rounded-lg hover:shadow-lg w-3/4"
						>
							Sign in with Auth0
						</Button>
					</div>
				</Paper>
			</Zoom>
		</Box>
	)
}
export default AdLogin
